import {IBackendInfo} from 'models/backendInfo';
import packageJson from '../../package.json';

interface PackageJson {
  homepage?: string;
  version: string;
  dependencies: {
    [key: string]: string;
  };
}

interface IGetCCVersionItems {
  name: string;
  version: string;
  id: string;
}

const {homepage = undefined, version, dependencies} = (packageJson as PackageJson) || undefined;

export const isCommandCenter = homepage ? homepage.indexOf('cms') > -1 : false;

export const getCCVersionItems = (backendInfo: IBackendInfo | undefined): IGetCCVersionItems[] => {
  return [
    {name: 'CMS App', version, id: 'cmsAppVersion'},
    ...(backendInfo?.app?.version ? [{name: 'CMS API', version: backendInfo.app.version, id: 'cmsApiVersion'}] : []),
    {name: 'Assemble', version: dependencies['@pluto-tv/assemble'] ?? '—', id: 'assembleVersion'},
  ];
};

export const getBaseUrl = (): string => (isCommandCenter ? '/cms/api/v1/' : '/v1/');
